export default __webpack_public_path__ + "static/media/settings.69d1fa29.svg";